/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ applied: NonNullable<unknown>, total: NonNullable<unknown>, percent: NonNullable<unknown> }} Sync_Phase_Applying_ProgressInputs */



/**
* | output |
* | --- |
* | "Saving changes... {applied} of {total} ({percent}%)" |
*
* @param {Sync_Phase_Applying_ProgressInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sync_phase_applying_progress = /** @type {((inputs: Sync_Phase_Applying_ProgressInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sync_Phase_Applying_ProgressInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Änderungen werden gespeichert... ${i?.applied} von ${i?.total} (${i?.percent} %)`)
	return /** @type {LocalizedString} */ (`Saving changes... ${i?.applied} of ${i?.total} (${i?.percent}%)`)
});